import type { ReactNode } from "react";
import MultipleChoicePieChart from "./MultipleChoicePieChart";
import MultiSelectBarChart from "./MultiSelectBarChart";
import { selectedOptionLabels } from "./answerOptions";
import { QuestionType } from "@pulse/api/surveyApi";
import { CommentHeader, CommentLayout, Comments } from "../../Comments/Comments";
import useComment from "../../Comments/useComment";
import { QuestionContent, QuestionHeader, QuestionResponse, ResponseLayout } from "../../Layouts";
import useQuestionResponse from "../../useQuestionResponse";

function MultipleChoiceCommentCompact() {
    const { answer } = useComment();
    return (
        <MultipleChoiceComment>
            <div className="font-light italic max-w-full max-h-6 flex items-start">
                <span>&quot;</span>
                <p className="truncate">{answer.comment?.answerComment}</p>
                <span>&quot;</span>
            </div>
        </MultipleChoiceComment>
    );
}

function MultipleChoiceCommentFull() {
    const { answer } = useComment();
    return (
        <div className="border-b border-container-outline w-full pb-4 group-last:border-0">
            <MultipleChoiceComment>
                <div className="font-light italic flex items-start max-w-full whitespace-pre-wrap">
                    <p>&quot;{answer.comment?.answerComment}&quot;</p>
                </div>
            </MultipleChoiceComment>
        </div>
    );
}

function MultipleChoiceComment({ children }: { children?: ReactNode }) {
    const { question } = useQuestionResponse();
    const { answer } = useComment();

    const optionText = selectedOptionLabels(question.questionOptions, answer.answerValue);

    return (
        <div className="pl-2 max-w-full">
            <h2 className="font-medium text-sm">{optionText}:</h2>
            {children}
        </div>
    );
}

function ChoiceChart() {
    const { question } = useQuestionResponse();

    return question.questionType === QuestionType.MULTI_SELECT ? (
        <MultiSelectBarChart />
    ) : (
        <MultipleChoicePieChart />
    );
}

export default function MultipleChoiceQuestionResponse() {
    return (
        <ResponseLayout>
            <QuestionResponse>
                <QuestionHeader />
                <QuestionContent>
                    <ChoiceChart />
                </QuestionContent>
            </QuestionResponse>
            <CommentLayout>
                <CommentHeader>
                    <MultipleChoiceCommentFull />
                </CommentHeader>
                <Comments>
                    <MultipleChoiceCommentCompact />
                </Comments>
            </CommentLayout>
        </ResponseLayout>
    );
}
